import { Alert, Box, Typography, useTheme } from '@mui/material';

const FeatureNotSupportedDialog = ({ title, description }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'left',
        padding: theme.spacing(4),
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '8px',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[2],
        margin: 'auto',
      }}
    >
      <Typography variant="h5" component="h2" gutterBottom>
        {title}
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        {description}
      </Typography>
      <Typography variant="subtitle2" color="textSecondary" borderLeft={`5px solid #FFA726`}>
        <Alert icon={false} severity="warning">
          This feature is not included in your subscription. Please reach out to{' '}
          <a href="mailto:support@marmin.ai" style={{ color: theme.palette.primary.main }}>
            support@marmin.ai
          </a>{' '}
          to get access.
        </Alert>
      </Typography>
    </Box>
  );
};

export default FeatureNotSupportedDialog;
